import { Component, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';

import { Observable, map } from 'rxjs';

import { ButtonIcon, ButtonTheme, ResponsiveImage } from '@fcom/ui-components';

import { AspectRatioString, ElementActions, ElementTypes, GaContext } from '../../interfaces';
import { GtmService } from '../../gtm';
import { FragmentService, MediaQueryService } from '../../services';

@Component({
  selector: 'fin-promotion-banner',
  templateUrl: './promotion-banner.component.html',
  styleUrls: ['./promotion-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PromotionBannerComponent implements OnInit {
  private gtmService = inject(GtmService);
  private mediaQueryService = inject(MediaQueryService);
  private fragmentService = inject(FragmentService);

  protected readonly ButtonTheme = ButtonTheme;

  @Input()
  image$: Observable<ResponsiveImage>;

  @Input()
  aspectRatio$: Observable<AspectRatioString>;

  @Input()
  translationPrefix: string;

  @Input()
  url: string;

  @Input()
  imageFromFragment: string;

  @Input()
  buttonIcon: ButtonIcon;

  @Input()
  imagePosition: 'top' | 'left' = 'top';

  @Input() isExternalLink?: boolean;
  loadImageFromFragment = (fragment: string): Observable<ResponsiveImage> =>
    this.fragmentService.getCmsPictureFromFragment(fragment);

  ngOnInit(): void {
    this.aspectRatio$ = this.mediaQueryService
      .isBreakpoint$('mobile')
      .pipe(map((isMobile: boolean) => (isMobile ? '1x1' : '16x9')));

    if (this.imageFromFragment) {
      this.image$ = this.loadImageFromFragment(this.imageFromFragment);
    }
  }

  trackPromoBanner(banner: string): void {
    this.gtmService.trackElement(
      `${banner}-promotion-banner`,
      GaContext.BOOKING_FLOW,
      ElementTypes.BANNER,
      banner,
      ElementActions.CLICK
    );
  }
}
